// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__CTdFV","bannerContent":"Banner_bannerContent__4MR5w","link":"Banner_link__l85oK"};